import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import IniziamoIlRacconto from "./sections/IniziamoIlRacconto";
import CuriositaEDettagli from "./sections/CuriositaEDettagli";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <IniziamoIlRacconto />
      <CuriositaEDettagli />
      <Footer />
    </div>;
}